import { Routes } from '@angular/router';

import { InfluencerStreamsComponent } from '../../Targeting/components/InfluencerStreams/influencer-streams.component';

export const influencerStreamRoutes: Routes = [
    {
        path: '',
        component: InfluencerStreamsComponent,
        data: {title: 'Discover.influencerStreams.browserTitle'}
    },
    {
        path: '**',
        redirectTo: '/Discover/influencerstreams'
    }
];
